import { z } from 'zod'
export const planningTimeSchema = z
  .string()
  .regex(/^([01]\d|2[0-3]):[0-5]\d$/)
  .or(z.literal(''))
export const supplierPlanSchema = z
  .object({
    name: z.string().trim().max(300),
    contact: z.string().trim().max(500),
    arrival: planningTimeSchema.optional(),
    amount: z.number().int().min(0).max(100_000_000).optional(),
    paidAmount: z.number().int().min(0).max(100_000_000).optional(),
    paymentMethod: z.enum(['undecided', 'cash', 'card', 'transfer']).optional(),
    agreement: z.string().trim().max(5000).optional(),
  })
  .refine((value) => (value.paidAmount ?? 0) <= (value.amount ?? 0), {
    path: ['paidAmount'],
    params: { reason: 'payment-exceeds-price' },
  })
export type SupplierPlan = z.infer<typeof supplierPlanSchema>
